import React from 'react';
import { ITreeElementProps } from 'helpers/types/tree';

export const FilterLine: React.FC<ITreeElementProps> = () => {
   

    return (
        <p className='line'></p>
    )
}